/**
 * @file search-text-context.tsx
 * @description React Context для управления состоянием поискового текста в компоненте каталога Task Manager приложения. Предоставляет централизованную систему управления строкой поиска с провайдером SearchTextProvider для распространения состояния по дереву компонентов и хуком useSearchText для безопасного доступа к контексту поиска из любого дочернего компонента каталога с автоматической проверкой корректности использования контекста.
 * @author AI-Generated | Human-Reviewed
 * @created 2025-01-15
 * @updated 2025-01-15
 * @dependencies ['react']
 * @related-files ['src/features/catalog/catalog.provider.tsx', 'src/features/catalog/catalog.component.tsx', 'src/features/catalog/components']
 */

import { createContext, useState, useContext, FC, ReactNode } from 'react';

interface SearchTextContextType {
    searchText: string;
    setSearchText: (text: string) => void;
}

const SearchTextContext = createContext<SearchTextContextType | undefined>(undefined);

export const SearchTextProvider: FC<{ children: ReactNode }> = ({ children }) => {
    const [searchText, setSearchText] = useState<string>('');

    return <SearchTextContext.Provider value={{ searchText, setSearchText }}>{children}</SearchTextContext.Provider>;
};

export const useSearchText = (): SearchTextContextType => {
    const context = useContext(SearchTextContext);

    if (!context) {
        throw new Error('useSearchText must be used within a SearchTextProvider');
    }
    return context;
};
